/**
 * 실제 사용자 후기 (goifuneral.co.kr/review)
 * - 장례지도사·시설 이름 등 고유명사 제거하여 익명화
 * - schema의 Review entity에 사용 (화장장 / 장례식장 지역 리스트의 reviewBody)
 * - 총 후기 개수: 1,917건 (실제 사이트 누적, 2026-05 기준)
 *
 * 출처:
 * - review/1304/ — 가족기업 같은 정성
 * - review/1524/ — 정찰제 / 추모 테이블
 * - review/1951/ — 입관식 베테랑
 * - review/1972/ — 메모리얼 테이블 / 전통 장례
 * - review/2043/ — 입관식 예술성 / 봉안담
 */

const 전체_태그_후기들 = [
  "지방이라서 살짝 어긋남이 있었는데 대표님까지 나서서 챙겨주시고 세심하게 인사하여 주시는 모습에 기업이 아니라 정말 가족이 되어서 가족을 챙겨주고 싶은 그런 가족기업이구나를 분명하게 느꼈습니다.",
  "합리적이고 투명한 정찰제 가격으로 운영되었고, 세부 항목별 가격이 명확하게 공개되어 있어 믿음이 갔습니다. 패키지에 포함된 품목 중 미사용 시 공제해 준다는 점 역시 큰 신뢰로 다가왔습니다.",
  "입관을 진행하시는 손길 하나하나에서 정말 경험이 많은 베테랑이신 게 느껴졌고, 태도에서도 대충 허투루 하는 것 하나 없이 정성스레 모셔 주셨습니다. 가족들 말로는 훨씬 더 제대로 작별 인사를 할 수 있었던 느낌이었다고 합니다.",
  "메모리얼 테이블이 정말 기억에 많이 남았습니다. 사진들을 전시하면서 추모해 주러 오신 많은 분들과 일대기를 공유하며 추억을 회상할 수 있었고, 화장과 장지까지 옮겨지는 동안에도 편안하고 안전하게 전통적으로 잘 진행해 주셨습니다.",
  "수의를 입히고 삼베띠를 묶는 과정에서 기구를 사용하지 않고 일일이 띠를 보내며 꽃봉오리처럼 마무리하는 모습은 예술적 완성도가 높았습니다. 유연하면서도 물 흐르는 듯한 리드로 유족들은 차분하고 평온한 장례를 치렀습니다.",
];

export const 후기_리치서치_컨텐츠들 = {
  전체: 전체_태그_후기들,
};

export const 후기_리치서치_컨텐츠_개수들 = {
  전체: "1917",
};
